import checkmark from './checkmark.svg';
import chevronDown from './chevron-down.svg';
import chevronLeft from './chevron-left.svg';
import chevronRight from './chevron-right.svg';
import chevronUp from './chevron-up.svg';
import close from './close.svg';
import info from './info.svg';
import lifebuoy from './lifebuoy.svg';
import logo from './logo.svg';
import quote from './quote.svg';
import voucherSmall from './voucher-small.svg';
import pdf from './pdf.svg';
import voucher from './voucher.svg';
import voucherWhite from './voucher-white.svg';
import quoteSmall from './quote-small.svg';
import priceCampaign from './price-campaign.svg';
import priceCampaignSmall from './price-campaign-small.svg';
import startInsurance from './start-insurance.svg';
import circleBackground from './circle-background.svg';
import circleBackground1 from './circle-background1.svg';
import Lejlighed from './apartment.svg';
import Hus from './villa.svg';
import Rækkehus from './terrace-house.svg';
import ownedCar from './car.svg';
import CouplewithkidsOne from './couple-one-kid.svg';
import CouplewithkidsTwo from './couple-two-kid.svg';
import CouplewithkidsThree from './couple-three-kid.svg';
import CouplewithkidsFour from './couple-four-kid.svg';
import CouplewithkidsFive from './couple-five-kid.svg';
import SinglewithkidsOne from './single-one-kid.svg';
import SinglewithkidsTwo from './single-two-kid.svg';
import SinglewithkidsThree from './single-three-kid.svg';
import SinglewithkidsFour from './single-four-kid.svg';
import SinglewithkidsFive from './single-five-kid.svg';
import Couplenokids from './couple-no-kid.svg';
import Singlenokids from './single-no-kid.svg';
import kidsOne from './kidsOne.svg';
import kidsTwo from './kidsTwo.svg';
import kidsThree from './kidsThree.svg';
import kidsFour from './kidsFour.svg';
import kidsFive from './kidsFive.svg';
import CouplewithkidsType from './couplewithkids.svg';
import SinglenokidsType from './singlenokid.svg';
import CouplenokidsType from './couplenokid.svg';
import SinglewithkidsType from './singlewithkids.svg';
import euMap from './map-eu.svg';
import worldMap from './map-world.svg';
import popupIllustration from './popup-illustration.svg';
import vaccine from './vaccine.svg';
import add from './add.svg';
import LejlighedTjm from './tjm/apartmentTjm.svg';
import HusTjm from './tjm/villa.svg';
import RækkehusTjm from './tjm/terrace-house.svg';
import ownedCarTjm from './tjm/car.svg';
import CouplewithkidsOneTjm from './tjm/couple-one-kid.svg';
import CouplewithkidsTwoTjm from './tjm/couple-two-kid.svg';
import CouplewithkidsThreeTjm from './tjm/couple-three-kid.svg';
import CouplewithkidsFourTjm from './tjm/couple-four-kid.svg';
import CouplewithkidsFiveTjm from './tjm/couple-five-kid.svg';
import SinglewithkidsOneTjm from './tjm/single-one-kid.svg';
import SinglewithkidsTwoTjm from './tjm/single-two-kid.svg';
import SinglewithkidsThreeTjm from './tjm/single-three-kid.svg';
import SinglewithkidsFourTjm from './tjm/single-four-kid.svg';
import SinglewithkidsFiveTjm from './tjm/single-five-kid.svg';
import CouplenokidsTjm from './tjm/couple-no-kid.svg';
import SinglenokidsTjm from './tjm/single-no-kid.svg';
import SinglenokidsTypeTjm from './tjm/singlenokid.svg';
import CouplenokidsTypeTjm from './tjm/couplenokid.svg';
import CouplewithkidsTypeTjm from './tjm/couplewithkids.svg';
import SinglewithkidsTypeTjm from './tjm/singlewithkids.svg';
import splashBanner from './splashbanner.svg';
import HusHousehold from './villa-household.svg';
import RækkehusHousehold from './terrace-house-household.svg';
import LejlighedHousehold from './apartment-household.svg';
import Travel from './travel.svg';
import travelSliderIcon from './travel-slider-icon.svg';
import Person from './person.svg';
import sliderleftarrow from './slider-left-arrow.svg';
import sliderrightarrow from './slider-right-arrow.svg';
import MedicalHotline from './medical-hotline.svg';
import DangerousSport from './dangerous-sport.svg';
import MotorcycleCost from './motorcycle-cost.svg';
import CouplewithkidsOneTravel from './couple-one-kid-travel.svg';
import CouplewithkidsTwoTravel from './couple-two-kid-travel.svg';
import CouplewithkidsThreeTravel from './couple-three-kid-travel.svg';
import CouplewithkidsFourTravel from './couple-four-kid-travel.svg';
import CouplewithkidsFiveTravel from './couple-five-kid-travel.svg';
import SinglewithkidsOneTravel from './single-one-kid-travel.svg';
import SinglewithkidsTwoTravel from './single-two-kid-travel.svg';
import SinglewithkidsThreeTravel from './single-three-kid-travel.svg';
import SinglewithkidsFourTravel from './single-four-kid-travel.svg';
import SinglewithkidsFiveTravel from './single-five-kid-travel.svg';
import CouplenokidsTravel from './couple-no-kid-travel.svg';
import SinglenokidsTravel from './single-no-kid-travel.svg';
import higherCloudIcon from './higher-cloud.svg';
import mediumCloudIcon from './medium-cloud.svg';
import lowerCloudIcon from './lower-cloud.svg';
import tjmKidsOne from './tjm/tjm-kids_one.svg';
import tjmKidsTwo from './tjm/tjm-kids_two.svg';
import tjmKidsThree from './tjm/tjm-kids_three.svg';
import tjmKidsFour from './tjm/tjm-kids_four.svg';
import tjmKidsFive from './tjm/tjm-kids_five.svg';
import arrowLeft from './arrow-left.svg';

const icons = {
  checkmark,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  close,
  info,
  lifebuoy,
  logo,
  quote,
  voucherSmall,
  pdf,
  voucher,
  voucherWhite,
  quoteSmall,
  priceCampaign,
  priceCampaignSmall,
  startInsurance,
  circleBackground,
  circleBackground1,
  Lejlighed,
  Hus,
  Rækkehus,
  ownedCar,
  CouplewithkidsOne,
  CouplewithkidsTwo,
  CouplewithkidsThree,
  CouplewithkidsFour,
  CouplewithkidsFive,
  SinglewithkidsOne,
  SinglewithkidsTwo,
  SinglewithkidsThree,
  SinglewithkidsFour,
  SinglewithkidsFive,
  Couplenokids,
  Singlenokids,
  kidsOne,
  kidsTwo,
  kidsThree,
  kidsFour,
  kidsFive,
  CouplewithkidsType,
  SinglenokidsType,
  CouplenokidsType,
  SinglewithkidsType,
  euMap,
  worldMap,
  popupIllustration,
  vaccine,
  add,
  LejlighedTjm,
  HusTjm,
  RækkehusTjm,
  ownedCarTjm,
  SinglewithkidsOneTjm,
  CouplewithkidsOneTjm,
  CouplewithkidsTwoTjm,
  CouplewithkidsThreeTjm,
  CouplewithkidsFourTjm,
  CouplewithkidsFiveTjm,
  SinglewithkidsTwoTjm,
  SinglewithkidsThreeTjm,
  SinglewithkidsFourTjm,
  SinglewithkidsFiveTjm,
  CouplenokidsTjm,
  SinglenokidsTjm,
  SinglenokidsTypeTjm,
  CouplenokidsTypeTjm,
  CouplewithkidsTypeTjm,
  SinglewithkidsTypeTjm,
  splashBanner,
  HusHousehold,
  RækkehusHousehold,
  LejlighedHousehold,
  Travel,
  travelSliderIcon,
  Person,
  sliderleftarrow,
  sliderrightarrow,
  MedicalHotline,
  DangerousSport,
  MotorcycleCost,
  CouplewithkidsOneTravel,
  CouplewithkidsTwoTravel,
  CouplewithkidsThreeTravel,
  CouplewithkidsFourTravel,
  CouplewithkidsFiveTravel,
  SinglewithkidsOneTravel,
  SinglewithkidsTwoTravel,
  SinglewithkidsThreeTravel,
  SinglewithkidsFourTravel,
  SinglewithkidsFiveTravel,
  CouplenokidsTravel,
  SinglenokidsTravel,
  higherCloudIcon,
  mediumCloudIcon,
  lowerCloudIcon,
  tjmKidsOne,
  tjmKidsTwo,
  tjmKidsThree,
  tjmKidsFour,
  tjmKidsFive,
  arrowLeft,
};

export default icons;


// WEBPACK FOOTER //
// ./src/assets/icons/index.js